import { Box, Typography, CircularProgress, keyframes } from "@mui/material";

const pulse = keyframes`
  0% { transform: scale(1); opacity: 0.7; }
  50% { transform: scale(1.1); opacity: 1; }
  100% { transform: scale(1); opacity: 0.7; }
`;

const DialogLoading = ({
  title = "Processing your request...",
  content = "Please wait while we prepare the content",
}) => {
  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      justifyContent='center'
      py={6}
    >
      <CircularProgress
        color='primary'
        size={48}
        thickness={4}
        sx={{
          animation: `${pulse} 1.5s ease-in-out infinite`,
          mb: 3,
          filter: "drop-shadow(0px 4px 8px rgba(96, 63, 151, 0.3))",
        }}
        aria-label='Loading form'
      />
      <Typography
        variant='h6'
        color='primary.main'
        sx={{ fontWeight: 600, textAlign: "center" }}
      >
        {title}
      </Typography>
      <Typography
        variant='body2'
        color='text.secondary'
        sx={{ mt: 1, textAlign: "center" }}
      >
        {content}
      </Typography>
    </Box>
  );
};

export default DialogLoading;
